const products = [
  {
    id: "vpn",
    category: "Security",
    name: "VPN",
    tagline: "Shield Your Digital Privacy",
    description:
      "A powerful VPN application engineered for iOS that encrypts your internet connection, masks your IP address, and keeps your personal data safe from prying eyes — wherever you go.",
    features: ["Military-grade encryption", "Zero-log policy", "Global server access", "One-tap connection"],
    image:
      "https://public.readdy.ai/ai/img_res/b3dba65ebf566e3cfa9453c48b6e26b4.jpg",
    seq: "vpn_product_001",
  },
  {
    id: "cleaner",
    category: "Performance",
    name: "Cleaner",
    tagline: "Optimize Your Device",
    description:
      "A comprehensive iOS cleaner that intelligently removes junk files, clears cache, and optimizes storage — giving your iPhone or iPad a fresh, faster performance every single day.",
    features: ["Smart junk detection", "Photo duplicate finder", "Memory boost", "Privacy cleaner"],
    image:
      "https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20performance%20optimization%20visualization%20on%20dark%20background%2C%20circular%20progress%20rings%20with%20sparkle%20particle%20effects%20and%20glowing%20golden%20accents%2C%20clean%20storage%20concept%20with%20flowing%20particles%2C%20premium%20mobile%20app%20quality%20illustration%2C%20minimal%20flat%20style%20with%20warm%20amber%20light%2C%20no%20text&width=600&height=480&seq=cleaner_product_001&orientation=landscape",
    seq: "cleaner_product_001",
  },
];

export default function Products() {
  return (
    <section id="products" className="w-full bg-[#0d0d0d] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-20">
          <p className="text-[#C9A85C] text-xs tracking-[5px] uppercase font-medium mb-4">
            Our Solutions
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Modern Applications
            <br />
            <span className="font-light text-white/50">for the iOS Platform</span>
          </h2>
          <p className="text-white/50 text-lg max-w-xl mx-auto leading-relaxed">
            Each product is crafted with precision to deliver a seamless,
            intuitive experience on every Apple device.
          </p>
          <div className="mt-8 mx-auto w-16 h-px bg-gradient-to-r from-transparent via-[#C9A85C] to-transparent" />
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {products.map((product) => (
            <article
              key={product.id}
              className="group bg-white/[0.02] border border-white/[0.07] rounded-3xl overflow-hidden hover:border-[#C9A85C]/20 transition-all duration-500"
            >
              {/* Product image */}
              <div className="w-full h-64 overflow-hidden relative">
                <img
                  src={product.image}
                  alt={`${product.name} iOS application`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0d0d0d]" />
                <span className="absolute top-5 left-5 text-[#C9A85C] text-xs tracking-[3px] uppercase bg-[#C9A85C]/10 border border-[#C9A85C]/20 px-3 py-1 rounded-full">
                  {product.category}
                </span>
              </div>

              {/* Product info */}
              <div className="p-8">
                <h3 className="text-4xl font-bold text-white mb-1">{product.name}</h3>
                <p className="text-[#C9A85C] text-sm font-medium tracking-wider mb-4">
                  {product.tagline}
                </p>
                <p className="text-white/55 text-base leading-relaxed mb-8">
                  {product.description}
                </p>
                {/* Features */}
                <ul className="grid grid-cols-2 gap-3">
                  {product.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 text-sm text-white/50">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-[#C9A85C]" />
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
